import { useQuery } from '@tanstack/react-query';
import { orderService } from '@/api/services/OrderService';
import { useAuth } from '@/stores/authContext';

export const REQUIRED_DATA_QUERY_KEY = ['requiredData'] as const;

// Статус обязательных данных для баннера. Повторы при сбое — на уровне транспорта (идемпотентный
// GET: сеть/5xx с backoff). React Query retry НЕ включаем (иначе двойной слой повторов). При провале
// баннер просто скрыт (data === undefined), не блокируя UI (см. спеку C2).
export function useRequiredData() {
  const { isAuthenticated } = useAuth();
  return useQuery({
    queryKey: REQUIRED_DATA_QUERY_KEY,
    queryFn: () => orderService.getRequiredData(),
    enabled: isAuthenticated,
    staleTime: 60_000,
  });
}
